"use strict";

(function () {
  const CLASS_KM_SPINNER_PLACE = 'km-spinner-place';
  function initSpinnerPlaceElements(rootElement) {
    const parentElements = rootElement.getElementsByClassName(CLASS_KM_SPINNER_PLACE);
    for (let i = 0; i < parentElements.length; i++) {
      const parentElement = parentElements[i];
      parentElement.innerHTML = window.km_spinner.html;
    }
  }
  window.km_spinner = {
    html: '<div class="km-spinner"><div></div></div>',
    htmlLight: '<div class="km-spinner --light"><div></div></div>',
    initSpinnerPlaceElements
  };
  onDOMReady(() => {
    initSpinnerPlaceElements(document.body);
  });
})();

// jQuery free